<template>
  <modal
    id="qrcode-modal"
    name="qrcode-modal"
    :draggable="isMobile() ? false : '.modal-header'"
    class="doi-modal"
    width="400"
    height="480"
    @before-open="beforeOpen"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t("qr.desc") }}</h5>
        <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="$modal.hide('qrcode-modal');"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <VueQrcode :value="url" :options="{ width: 350 }"></VueQrcode>
        </div>
        <a v-if="false" :href="url">{{url}}</a>
      </div>
    </div>
  </modal>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
export default {
  components: {
    VueQrcode,
  },
  data() {
    return {
      url: "",
    }
  },
  methods: {
    beforeOpen() {
      this.url = window.location.href;
    }
  }
};
</script>

<style lang="css" scoped>
  .modal-body {
    text-align: center;
  }
</style>
